jQuery(document).ready(function ($) {
  // click on second level menu with children
  $(".dropdown-item.has-children").on("click", function (e) {
    e.preventDefault();

    // TODO WR: update menu__mega-outer class as required
    const dropdown = $(this).closest(".menu__mega-outer");
    const target = $(this).data("target");

    // remove the default image from the parent menu item if it is present
    dropdown
      .find(".menu__third-level-rollover-image.active")
      .removeClass("active");

    // remove from existing third level menu
    dropdown.find(".third-level.active").removeClass("active");

    // remove from existing parent
    dropdown.find(".dropdown-item.active").removeClass("active");

    // add to this element
    $(this).addClass("active");

    // add to the menu
    dropdown.find(".third-level." + target).addClass("active");
  });

  // listener for hover on top level menu item with children
  $(".top-level.menu-item-has-children").on("mouseenter", function () {
    $(".header__outer").addClass("mega-menu-active");
    document.body.classList.add("mega-menu-active");
  });

  // listener for hover leave on top level menu item with children
  $(".top-level.menu-item-has-children").on("mouseleave", function () {
    $(".header__outer").removeClass("mega-menu-active");
    document.body.classList.remove("mega-menu-active");

    setTimeout(function () {
      $(".default-image.menu__third-level-rollover-image").addClass("active");
    }, 500);
  });
});
